const hasPermission = ({ actions = "" }) => {
  // Lấy quyền từ localStorage (đã decode)
  let storedPermissions = [];

  try {
    const data = localStorage.getItem("permissions");
    // console.log(data, "data");

    if (data) {
      const decoded = atob(data); // Giải mã base64
      storedPermissions = JSON.parse(decoded).map((p) => p.toLowerCase());
    }
  } catch (e) {
    console.error("Invalid permissions in localStorage:", e);
  }

  if (!storedPermissions || storedPermissions.length === 0) return false;

  // Nếu actions rỗng => mặc định cho phép
  if (!actions || (Array.isArray(actions) && actions.length === 0)) return true;

  // Trường hợp actions là string
  if (typeof actions === "string") {
    return storedPermissions.includes(actions.toLowerCase());
  }

  // Trường hợp actions là mảng
  const mustHave = actions
    .filter((a) => typeof a === "string")
    .every((a) => storedPermissions.includes(a.toLowerCase()));

  const mustOneOf = actions
    .filter((a) => Array.isArray(a))
    .some((group) =>
      group.every((a) => storedPermissions.includes(a.toLowerCase()))
    );

  return mustHave && (mustOneOf || actions.every((a) => typeof a === "string"));
};

export default hasPermission;
